import { render, staticRenderFns } from "./CarClock.vue?vue&type=template&id=2d596171&"
import script from "./CarClock.vue?vue&type=script&lang=js&"
export * from "./CarClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports